__turbopack_context__.v({
  "agentInfoContainer": "A1WtbG_agentInfoContainer",
  "agentInfoContainerCenter": "A1WtbG_agentInfoContainerCenter",
  "agentInfoContainerCompanyInfo": "A1WtbG_agentInfoContainerCompanyInfo",
  "agentInfoContainerCompanyInfoBody": "A1WtbG_agentInfoContainerCompanyInfoBody",
  "agentInfoContainerCompanyInfoHeader": "A1WtbG_agentInfoContainerCompanyInfoHeader",
  "agentInfoContainerCompanyInfoLeft": "A1WtbG_agentInfoContainerCompanyInfoLeft",
  "agentInfoContainerCompanyInfoRight": "A1WtbG_agentInfoContainerCompanyInfoRight",
  "agentName": "A1WtbG_agentName",
  "agentTitle": "A1WtbG_agentTitle",
  "banner": "A1WtbG_banner",
  "bannerContainer": "A1WtbG_bannerContainer",
  "bannerImage": "A1WtbG_bannerImage",
  "profilePhoto": "A1WtbG_profilePhoto",
  "profilePhotoContainer": "A1WtbG_profilePhotoContainer",
});
